module.exports = __webpack_public_path__ + "static/media/slider3img.f841ea78.jpg";